import { get_el, set_defaults } from 'js/utils';
import Hooks from 'js/hooks';

export default class Text_Input_Submit {
	constructor(input, options = {}) {
		input = get_el(input);
		if (!input) return;

		this.input = input;

		this.options = set_defaults(
			{
				type_internval: 500,
			},
			options,
		);

		this.hooks = new Hooks();

		init_type_submit(this);
	}
}

function init_type_submit($this) {
	let timer;
	let last_search = '';

	const submit = () => {
		if (last_search === $this.input.value) return;
		last_search = $this.input.value;
		$this.hooks.do('submit', last_search);
	};

	$this.input.addEventListener('keyup', (e) => {
		clearTimeout(timer);

		if (e.key === 'Enter') {
			return submit();
		}

		timer = setTimeout(submit, $this.options.type_internval);
	});
}
